import * as sharedTypes from 'src/actions/shared/sharedTypes';
import ivrResource from 'src/actions/ivrs/ivrResource';
import PhoneNumber from 'src/models/PhoneNumberDef';
import validateType, { translateErrors } from 'src/adapters/validateType';

const validatePhoneNumber: sharedTypes.AppThunk = (phoneNumber: string) => dispatch => {
  try {
    validateType(PhoneNumber, { phoneNumber });
  } catch (err) {
    dispatch(ivrResource.actions.validationError(translateErrors((err as any).errors)));
    return false;
  }

  return true;
};

export default validatePhoneNumber;
